import React, {Fragment} from "react";
import { connect } from "react-redux";

import GroheCartDeliverySection from "./groheCartDeliverySection";
import {createDeliverySections} from "./deliveryFunctions";


const GroheCartDeliveryContent = (props) => {

  const {cartItems} = props;

  const deliveriesSections = createDeliverySections(cartItems);

  return (
    <Fragment>
      {deliveriesSections.map((delivery, deliveryIndex) => {
        if (!delivery.cartItems.length) {
          return null
        }
        return <GroheCartDeliverySection key={delivery.name + deliveryIndex} delivery={delivery}/>
      })}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  return {
    cartItems,
  };
};

export default connect(mapStateToProps)(GroheCartDeliveryContent)
